import React, { useEffect, useState } from "react";
import Confirm from "./Confirm";

const Uploader = (props) => {
  const [step, setStep] = useState("step2");
  const [files, setFiles] = useState([]);
  const newProps = {
    ...props.props,
    Attachments: files,
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const encodeFileBase64 = (file) => {
    var reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        var Base64 = reader.result.split(",")[1];
        setFiles([
          ...files,
          {
            fileName: file.name,
            documentBody: Base64,
            mimeType: file.type,
          },
        ]);
      };
      reader.onerror = function (error) {
        console.log("error:", error);
      };
    }
  };
  const handleChange = (e) => {
    const { files } = e.target;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      encodeFileBase64(file);
    }
  };
  const handleClick = (step) => {
    if (step == "step3") {
      setStep(step);
    }
  };
  return (
    <div className="riskassessment-footer">
      {step == "step2" && (
        <div className="step2-box">
          <div class="formhead">
            <i class="fa fa-upload">&nbsp;</i>
            <span>Application for Travel Assistance</span>
          </div>
          <h2>Step 2 - Supporting Documentation</h2>
          <hr />
          <p>
            If you are applying on medical grounds you must provide supporting
            evidence from a medical consultant.
          </p>
          {/* <p>
            Upload up to a maximum of 5 relevant supporting document(s) below
            before continuing with your application.
          </p> */}
          <p>
            The following file types are permitted:&nbsp;
            <span>doc,&nbsp;</span>
            <span>docx,&nbsp;</span>
            <span>jpeg,&nbsp;</span>
            <span>jpg,&nbsp;</span>
            <span>pdf,&nbsp;</span>
            <span>png&nbsp;</span>
          </p>
          <hr />
          <div class="panel panel-default">
            <div class="panel-body">
              <form>
                <div class="mb-3">
                  <label class="form-label" for="Data_FormFile">
                    Select file
                  </label>
                  <p>
                    <input
                      id="Data_FormFile"
                      name="Data.FormFile"
                      type="file"
                      onChange={handleChange}
                      accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png"
                      // multiple
                    />
                  </p>

                  {/* <div id="helpBlock" class="form-text text-danger">
                    Maximum file size: 50 MB.
                  </div> */}
                </div>
              </form>
            </div>
          </div>
          <hr />
          {files.length > 0 ? (
            files.map((f) => <p>{f.fileName}</p>)
          ) : (
            <div class="alert alert-warning" role="alert">
              <i class="fa fa-info-circle">&nbsp;</i>There are currently no
              supporting documents associated with your application.
            </div>
          )}
          <div class="alert alert-info" role="alert">
            When you have completed uploading supporting documentation, please
            continue to step 3.
          </div>
          <button
            className="index-form-btn"
            onClick={() => handleClick("step3")}
          >
            <i className="fa fa-arrow-circle-right" title="Continue to step 3">
              &nbsp;
            </i>
            Continue to step 3
          </button>
        </div>
      )}
      {step == "step3" && <Confirm props={newProps} />}
    </div>
  );
};

export default Uploader;
